<template>
  <div>
    <a-modal :title="title"
             :visible="dialogVisible"
             @cancel="handleCancel"
             :footer="null"
    >
      <div class="image-img">
        <img :src="imageUrl" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PreviewImage',
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '模板预览'
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    handleCancel() {
      this.$emit('close')
    }
  }

}
</script>
<style lang="less" scoped>
.image-img {
  width: 100%;
  height: auto;

  img {
    width: 100%;
    height: auto;
  }
}
</style>